import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { AuthenticationPageLayout } from '@/app/shell/AuthenticationPageLayout';

export function NotFoundPage() {
  const { t } = useTranslation();

  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Not found';
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <AuthenticationPageLayout>
      <div>
        <p role="alert">
          {t('Error_PageNotFound', {
            defaultValue: 'Page not found. It seems like you opened wrong link.',
          })}
        </p>
        <div>
          <Link to="/incident-list" className="btn btn-primary">
            {t('Error_BackToHomeButton', { defaultValue: 'Continue to home page' })}
          </Link>
        </div>
      </div>
    </AuthenticationPageLayout>
  );
}
